<template>
    <v-card>
        <v-card-title class="primary titulo-recusa">
          <p >Recusar Cotação</p>
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs12 md6>
                    <v-select
                        :items="listaMotivosRecusa"
                        item-text="titulo"
                        item-value="id"
                        v-model="modelRecusar.idMotivoRecusa"
                        label="Motivo da recusa"
                    >
                    </v-select>
                </v-flex>
                <v-flex xs12 md12 v-show="desabilitarMotivoText">
                    <v-textarea
                        v-model="modelRecusar.campoDescricao"
                        outline

                        label="Informe o motivo"
                        rows="4"
                    ></v-textarea>
                </v-flex>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-layout class="special-flex-recusa">
                <v-btn @click="tratamentoFecharModal" color="primary" flat>Cancelar</v-btn>
                <v-btn :disabled="desabilitarBotaoRecusar" @click="recusarCotacao" color="primary">Recusar</v-btn>
            </v-layout>
        </v-card-actions>
        <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
            {{ snackText }}
            <v-btn flat @click="snack = false">Fechar</v-btn>
          </v-snackbar>
      
      </v-card>
</template>
<script>
import usuarioHelper from "@/helpers/usuario-logado.js";
import axios from "axios";
import motivosRecusaEnum from "@/helpers/motivo-recusa-enum.js";
export default {
    name:"ModalRecusarCotacao",
    props: {
        idApolice: {
            type: Number,
            required: false, 
        }
    },
    data() { return {
        modelRecusar: {
            idMotivoRecusa: null, 
            campoDescricao: null,
        },
        listaMotivosRecusa: [],
        snackColor: "",
        snackText: "",
        snack: false,
    }
    },
    mounted() {
        this.retornarMotivosRecusa();
    },
    computed: {
       
        desabilitarMotivoText() {
            return this.modelRecusar.idMotivoRecusa == motivosRecusaEnum.motivosRecusa.OUTRO_MOTIVO;
        },
        desabilitarBotaoRecusar() {
            
            if(this.modelRecusar.idMotivoRecusa !=null) {
                if(this.modelRecusar.idMotivoRecusa == motivosRecusaEnum.motivosRecusa.OUTRO_MOTIVO && this.modelRecusar.campoDescricao == null) {
                    return true
                }
                return false;
            }
            return true
        }
    },
    methods: {
        limparDadosForm() {
            this.modelRecusar.idMotivoRecusa = null;
            this.modelRecusar.campoDescricao = null;
        },
        tratamentoFecharModal() {
            this.limparDadosForm();
            this.$emit('fecharModalRecusa');
        },
        retornarMotivosRecusa() {
            axios.get(
                `${process.env.URL_APOLICEMS}/v1/buscarListaMotivoRecusa`, {
                    headers: {
                        Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
                    }
                })
                .then(res => {
                    this.listaMotivosRecusa = res.data;
                })
                .catch(err => {});
        },
        recusarCotacao() {
            if(this.idApolice != 0) {
                axios.post(
                `${process.env.URL_APOLICEMS}/v1/recusarCotacao/${parseInt(this.idApolice)}`, this.modelRecusar,
                {
                    headers: {
                        Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
                    }
                }
                )
                .then(() => {
                    this.snack = true;
                    this.snackColor = "success";
                    this.snackText = "Cotação recusada com sucesso";
                    setTimeout(() => {
                        this.$router.push('/GridPrincipal')
                    }, 1500);
                }) 
                .catch(err => {
                    this.snack = false;
                    this.snackColor = "error";
                    this.snackText = "Ocorreu um erro ao tentar recusar esta cotação";
                });
            }
            
        },
    },
    saveStatus() {
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Cotação recusada com sucesso";
    }
}

</script>
<style>
.titulo-recusa p {
    color: white!important;
    font-size: 18px;
    margin: 0
}
.special-flex-recusa {
    display: flex;
    justify-content: end;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/frota/ModalRecusarCotacao.vue